// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__ZHqwb","ranges":"BmiRanges_ranges__1rWCQ"};